<div class="flex-grow-1 bg-image">
  @if (!loading) {
    <header class="shadow bg-light bg-opacity-50">
      <div class="py-4 container-lg">
        <h4 class="m-0 flex-wrap text-break">
          <button (click)="goBack()"
                  class="btn btn-light text-primary">
            <i class="text-muted fa-solid fa-angle-left"></i>
            <span class="ps-1">Назад</span>
          </button>
          <span class="align-middle">
          {{ adDetails.title }}
        </span>
        </h4>
        @if (adDetails.identifier) {
          <h6 class="mb-0 mt-2 text-muted"># {{ adDetails.identifier }}</h6>
        }
      </div>
    </header>
    <section class="my-4 container-lg">
      <nav class="d-flex align-items-center flex-wrap">
        <a class="text-decoration-none"
           [routerLink]="[appRoutes.root, appRoutes.adList]">
          Обяви
        </a>
        <small class="mx-2 text-muted">
          <i class="fa-solid fa-chevron-right"></i>
        </small>
        <a class="text-decoration-none"
           [routerLink]="[appRoutes.root, appRoutes.adList]"
           [queryParams]="{adCategoryId: adDetails.adCategoryId}">
          {{ adDetails.adCategoryName }}
        </a>
        <small class="mx-2 text-muted">
          <i class="fa-solid fa-chevron-right"></i>
        </small>
        <a class="text-decoration-none" href="#"
           [routerLink]="[appRoutes.root, appRoutes.adList]"
           [queryParams]="{adCategoryId: adDetails.adCategoryId, adSubcategoryId: adDetails.adSubcategoryId}">
          {{ adDetails.adSubcategoryName }}
        </a>
      </nav>
    </section>
    @if (!adDetails.isDeleted) {
      @if (adDetails.isUserBlocked) {
        <section class="my-4 container-lg">
          <div class="alert alert-danger">
            <p class="mb-1 fw-medium">
              <i class="me-1 fas fa-exclamation-triangle" aria-hidden="true"></i>
              Достъпът до тази обява е ограничен!
            </p>
            <p class="m-0">
              Авторът на обявата е блокирал вашия профил. Затова не може да наддавате или да купувате артикули от този
              продавач.
            </p>
          </div>
        </section>
      }
      <section class="my-4 container-lg">
        <nz-ad-status-info/>
      </section>
      <section class="my-4 container-lg">
        <nz-ad-offer-section/>
      </section>
      <section class="my-4 container-lg">
        <div class="row g-4">
          <div class="col-12 col-lg-8">
            <nz-ad-carousel/>
          </div>
          <div class="col-12 col-lg-4">
            <div class="mb-4">
              <nz-ad-pricing-panel/>
            </div>
            <div class="mb-4">
              <nz-ad-time-panel/>
            </div>
            <div>
              @if (adDetails.isUserOwner) {
                <nz-actions-panel [adId]="adId"/>
              } @else {
                <nz-seller-panel/>
              }
            </div>
          </div>
        </div>
      </section>
      <section class="my-4 container-lg">
        <nz-description-section [adDetails]="adDetails"/>
      </section>
      <section class="my-4 container-lg">
        <nz-comments-section
          [adId]="adId"
          [isUserBlocked]="adDetails.isUserBlocked"
          [adComments]="adComments"/>
      </section>
      @if (isUserLoggedIn) {
        <section class="container-lg">
          <nz-last-visited-ads-section/>
        </section>
      }
    } @else {
      <section class="my-4 container-lg">
        <div class="alert alert-danger">
          <i class="me-2 text-danger fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
          <span>Обявата е изтрита!</span>
        </div>
      </section>
    }
  } @else {
    <nz-loader/>
  }
</div>
@if (fullscreenOverlay) {
  <div class="modal-backdrop fade show fullscreen-overlay">
    <div class="text-center text-white">
      <h1>
        <i class="fa-solid fa-spinner fa-spin"></i>
      </h1>
      <h5>Зареждане...</h5>
    </div>
  </div>
}
